/**
 * Curated display order for Frame SKUs in the Forecast view.
 *
 * This is March's merchandising order (by product family, then finish),
 * NOT anything derivable from the data — so it lives here as an explicit
 * list. Frames absent from this list still render, sorted alphabetically
 * after the listed ones, so a newly-catalogued SKU is never hidden.
 *
 * To reorder, just move lines around. Keep it in sync with the catalog.
 */
export const FRAME_SORT_ORDER: readonly string[] = [
  "AAT118A-002",
  "AAT604A-002",
  "AAT75754A-002",
  "AAT758A-002",
  "AAT908A-002",
  "AATF118AH-002",
  "AATF118AH-724",
  "AATF118AH-112",
  "AATF118AH-171",
  "AATF118AH-709",
  "AATF604AH-002",
  "AATF604AH-724",
  "AATF604AH-112",
  "AATF604AH-171",
  "AATF604AH-709",
  "AATF758AH-002",
  "AATF758AH-724",
  "AATF758AH-112",
  "AATF758AH-171",
  "AATF758AH-709",
  "AATF908AH-002",
  "AATF908AH-724",
  "AATF908AH-112",
  "AATF908AH-171",
  "AATF908AH-709",
  "AAT85858DT-002",
  "ALTO118-002",
  "ALTO118-117",
  "ALTO118-170",
  "ALTO118-302",
  "ALTO118-202",
  "ALTO118-112",
  "ALTO118-724",
  "ALTO604-002",
  "ALTO604-117",
  "ALTO604-170",
  "ALTO604-302",
  "ALTO604-202",
  "ALTO604-112",
  "ALTO604-724",
  "ALTO758-002",
  "ALTO758-117",
  "ALTO758-170",
  "ALTO758-302",
  "ALTO758-202",
  "ALTO758-112",
  "ALTO758-724",
  "ALTO908-002",
  "ALTO908-117",
  "ALTO908-170",
  "ALTO908-302",
  "ALTO908-202",
  "ALTO908-112",
  "ALTO908-724",
  "ATA758-117",
  "ATA908-117",
  "ATAF758-117",
  "ATAF908-117",
  "ATA758-170",
  "ATA908-170",
  "ATA758-302",
  "ATA908-302",
  "ATAF758-170",
  "ATAF908-170",
  "ATAF758-302",
  "ATAF908-302",
  "ES1188-117",
  "GSCU118-010",
  "GSCU118-117",
  "GSCU118-170",
  "GSCU118-302",
  "GSCU908-010",
  "GSCU908-117",
  "GSCU908-170",
  "GSCU908-302",
  "GSCU758-010",
  "GSCU758-117",
  "GSCU758-170",
  "GSCU758-302",
  "GSCUF118-010",
  "GSCUF118-117",
  "GSCUF118-170",
  "GSCUF118-705",
  "GSCUF758-010",
  "GSCUF758-117",
  "GSCUF758-170",
  "GSCUF758-705",
  "GSCUF908-010",
  "GSCUF908-117",
  "GSCUF908-170",
  "GSCUF908-705",
  "GSPT608-010",
  "GSPT608-117",
  "GSPT608-170",
  "GSPT608-302",
  "GSPT758-010",
  "GSPT758-117",
  "GSPT758-170",
  "GSPT758-302",
  "GSPT908-010",
  "GSPT908-117",
  "GSPT908-170",
  "GSPT908-302",
  "MARE604",
  "MARE758",
  "MARE908",
  "SDAU118-117",
  "SDAU908-117",
  "SMPTF852-174-PD",
  "SMPTF852-002-PD",
  "SMPTF852-201-PD",
  "SMPA310DPD-174",
  "SMCF852-174",
  "SMCF852-002",
  "SMPF758-174",
  "SMPF758-002",
  "STAF908-202",
  "STAF118-202",
  "STAF758-202",
  "STAF604-202",
  "PTS908-078",
  "SOLA118-001",
  "SOLA338-001",
  "SUPF758-112",
  "SUPF656-112",
  "EFFO758L-201",
  "EFFO908L-201",
  "HOKU338-171",
  "HOKU338-308",
  "HOKU438-171",
  "HOKU438-308",
  "HOKU-Base-Grey",
  "HOKU-Base-White",
  "SDAU1088-117",
  "LUNA774E-DT-174",
  "LUNA906B-DT-174",
  "ME6-36-308",
  "ME6-39-308",
  "ME8-43-308",
];

/** itemid -> position. Lookup is O(1) per row during sort. */
export const FRAME_SORT_INDEX: ReadonlyMap<string, number> = new Map(
  FRAME_SORT_ORDER.map((itemid, i) => [itemid, i]),
);

/**
 * Sort rank for a Frame. Unlisted SKUs get a rank past the end of the
 * list so they fall to the bottom (then sorted alphabetically by the
 * caller) rather than silently disappearing.
 */
export function frameSortRank(itemid: string): number {
  return FRAME_SORT_INDEX.get(itemid) ?? Number.MAX_SAFE_INTEGER;
}
